(function () {
  const qs = (s, c) => (c || document).querySelector(s);
  const qsa = (s, c) => Array.from((c || document).querySelectorAll(s));
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  function initAnnouncement(scope) {
    qsa('[data-benefits-rotator]', scope).forEach((wrap) => {
      if (wrap.dataset.pjInit === '1') return;
      wrap.dataset.pjInit = '1';
      const slides = qsa('[data-benefit-slide]', wrap);
      if (slides.length < 2) return;
      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (index < 0) index = 0;
      const delay = Number(wrap.dataset.delay || 2000);
      window.setInterval(() => {
        const prev = slides[index];
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        index = (index + 1) % slides.length;
        window.setTimeout(() => {
          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === index);
            slide.classList.remove('is-leaving');
          });
        }, 180);
      }, delay);
    });
  }

  function initHeader(scope) {
    qsa('[data-site-header]', scope).forEach((shell) => {
      if (shell.dataset.pjInit === '1') return;
      shell.dataset.pjInit = '1';
      const header = qs('.pj-header', shell);
      const toggle = qs('[data-mobile-toggle]', shell);
      const panel = qs('[data-mobile-panel]', shell);
      const toggleIcons = qsa('[data-toggle-icon]', shell);
      const panelSearchInput = qs('[data-mobile-panel] input[type="search"]', shell);

      const setToggleIcons = (open) => {
        toggleIcons.forEach((icon) => {
          const type = icon.getAttribute('data-toggle-icon');
          icon.style.display = (open && type === 'close') || (!open && type === 'menu') ? 'block' : 'none';
        });
      };

      const closePanel = () => {
        if (!toggle || !panel) return;
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        setToggleIcons(false);
      };

      const onScroll = () => {
        if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      if (toggle && panel) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          setToggleIcons(open);
          if (open && panelSearchInput) {
            window.setTimeout(() => {
              panelSearchInput.focus();
            }, 40);
          }
        });

        qsa('.pj-mobile-nav__link', panel).forEach((link) => {
          link.addEventListener('click', () => {
            closePanel();
          });
        });
      }

      qsa('.pj-nav__link, .pj-brandmark', shell).forEach((link) => {
        link.addEventListener('click', () => {
          closePanel();
        });
      });

      document.addEventListener('click', (event) => {
        if (!panel || !toggle || !panel.classList.contains('is-open')) return;
        if (panel.contains(event.target) || toggle.contains(event.target)) return;
        closePanel();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePanel();
        }
      });
    });
  }

  function initPredictiveSearch(scope) {
    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const moneyFormat = (window.Shopify && (window.Shopify.money_format || (window.theme && window.theme.moneyFormat))) || '${{amount}}';
    const formatMoney = (amount) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(amount, moneyFormat);
      }
      const value = Number(amount || 0) / 100;
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0
      }).format(value);
    };

    qsa('[data-search-shell]', scope).forEach((form) => {
      if (form.dataset.searchInit === '1') return;
      form.dataset.searchInit = '1';
      const input = qs('input[type="search"]', form);
      const results = qs('[data-search-results]', form);
      if (!input || !results) return;

      const noResultsTitle = form.dataset.noResultsTitle || 'Sin resultados';
      const noResultsTemplate = form.dataset.noResultsTemplate || 'No encontramos resultados para "__terms__".';
      const browseAllLabel = form.dataset.browseAllLabel || 'Ver catálogo';
      const searchingLabel = form.dataset.searchingLabel || 'Buscando…';
      const limit = Math.max(1, Number(form.dataset.searchLimit || 5));
      let debounceTimer = null;
      let controller = null;
      let lastTerm = '';

      const searchUrl = (term) => `/search?q=${encodeURIComponent(term)}&type=product&options%5Bprefix%5D=last`;

      const closeResults = () => {
        results.hidden = true;
        results.innerHTML = '';
        form.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      };

      const openResults = () => {
        results.hidden = false;
        form.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      };

      const renderNoResults = (term) => {
        const message = noResultsTemplate.replace('__terms__', escapeHtml(term));
        results.innerHTML = `
          <div class="pj-predictive-search__empty">
            <strong>${escapeHtml(noResultsTitle)}</strong>
            <p>${message}</p>
            <a class="pj-predictive-search__all" href="${searchUrl(term)}">${escapeHtml(browseAllLabel)}</a>
          </div>`;
        openResults();
      };

      const renderProducts = (products, term) => {
        const items = products.slice(0, limit).map((product) => {
          const imageSrc = typeof product.image === 'string'
            ? product.image
            : ((product.image && (product.image.url || product.image.src)) || (product.featured_image && (product.featured_image.url || product.featured_image.src)) || '');
          const image = imageSrc
            ? `<span class="pj-predictive-search__thumb"><img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title || '')}" loading="lazy"></span>`
            : '<span class="pj-predictive-search__thumb is-empty"></span>';
          return `
            <a class="pj-predictive-search__item" href="${escapeHtml(product.url || '#')}">
              ${image}
              <span class="pj-predictive-search__copy">
                <span class="pj-predictive-search__title">${escapeHtml(product.title || '')}</span>
                <span class="pj-predictive-search__price">${escapeHtml(formatMoney(product.price || 0))}</span>
              </span>
            </a>`;
        }).join('');

        results.innerHTML = `
          <div class="pj-predictive-search__list" role="listbox">${items}</div>
          <a class="pj-predictive-search__all" href="${searchUrl(term)}">${escapeHtml(browseAllLabel)}</a>`;
        openResults();
      };

      const runSearch = async (rawTerm) => {
        const term = String(rawTerm || '').trim();
        lastTerm = term;
        if (term.length < 2) {
          closeResults();
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();
        results.innerHTML = `<div class="pj-predictive-search__status">${escapeHtml(searchingLabel)}</div>`;
        openResults();

        try {
          const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=${limit}&resources[options][prefix]=last&resources[options][unavailable_products]=last`, {
            signal: controller.signal,
            headers: { 'Accept': 'application/json' }
          });
          if (!response.ok) throw new Error('predictive-search-error');
          const data = await response.json();
          if (lastTerm !== term) return;
          const products = (((data || {}).resources || {}).results || {}).products || [];
          if (products.length) renderProducts(products, term);
          else renderNoResults(term);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          closeResults();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        const term = input.value || '';
        if (term.trim().length < 2) {
          closeResults();
          return;
        }
        debounceTimer = window.setTimeout(() => {
          runSearch(term);
        }, 180);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && results.innerHTML.trim() !== '') {
          openResults();
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeResults();
          input.blur();
        }
      });

      form.addEventListener('submit', (event) => {
        const term = input.value.trim();
        if (!term) {
          event.preventDefault();
          closeResults();
          return;
        }
        closeResults();
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults();
      });
    });
  }

  function revealNowIfInView(item) {
    const rect = item.getBoundingClientRect();
    if (rect.top <= window.innerHeight * 0.95 && rect.bottom >= 0) {
      item.classList.add('is-visible');
      return true;
    }
    return false;
  }

  function initReveal(scope) {
    const items = qsa('.pj-reveal', scope).filter((item) => item.dataset.revealBound !== '1');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.revealBound = '1';
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach((item) => {
      item.dataset.revealBound = '1';
      if (!revealNowIfInView(item)) observer.observe(item);
    });
  }

  function initProcess(scope) {
    qsa('[data-process-section]', scope).forEach((section) => {
      if (section.dataset.processBound === '1') {
        if (typeof section._pjUpdateProcess === 'function') section._pjUpdateProcess();
        return;
      }
      section.dataset.processBound = '1';
      const steps = qsa('[data-process-step]', section);
      if (!steps.length) return;

      const update = () => {
        const rect = section.getBoundingClientRect();
        const viewH = window.innerHeight;
        const progress = clamp((viewH - rect.top) / (rect.height + viewH * 0.2), 0, 1);
        steps.forEach((step, index) => {
          const stepProgress = clamp((progress - index * 0.22) / 0.24, 0, 1);
          step.classList.toggle('is-active', stepProgress > 0.07);
          const fill = qs('[data-process-line-fill]', step);
          if (fill) fill.style.height = `${clamp((progress - index * 0.22 - 0.08) / 0.16, 0, 1) * 100}%`;
        });
      };

      section._pjUpdateProcess = update;
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  function initStories(scope) {
    qsa('[data-stories-root]', scope).forEach((section) => {
      if (section.dataset.storiesBound === '1') {
        if (typeof section._pjRenderStory === 'function') section._pjRenderStory();
        return;
      }
      section.dataset.storiesBound = '1';

      let slides = [];
      try {
        slides = JSON.parse(section.dataset.storiesItems || '[]');
      } catch (e) {
        slides = [];
      }
      if (!slides.length) return;

      const media = qs('[data-story-media]', section);
      const username = qs('[data-story-username]', section);
      const segs = qsa('[data-story-seg]', section);
      const nextBtns = qsa('[data-story-next]', section);
      const prevBtns = qsa('[data-story-prev]', section);
      let index = 0;
      let progress = 0;
      let autoplay = true;
      let touchStart = 0;
      let switchTimer = null;
      let progressTimer = null;

      function render() {
        const slide = slides[index] || {};
        if (media) {
          media.innerHTML = slide.image
            ? `<img class="pj-media__image" src="${slide.image}" alt="${slide.alt || ''}">`
            : '<div class="pj-media__placeholder"></div>';
        }
        if (username) username.textContent = slide.username || '';
        segs.forEach((seg, i) => {
          seg.classList.toggle('is-complete', i < index);
          const fill = qs('.pj-story__seg-fill', seg);
          if (fill) fill.style.width = i === index ? `${progress}%` : (i < index ? '100%' : '0%');
        });
      }

      function clearTimers() {
        if (progressTimer) window.clearInterval(progressTimer);
        if (switchTimer) window.clearInterval(switchTimer);
      }

      function start() {
        clearTimers();
        if (!autoplay) return;
        progressTimer = window.setInterval(() => {
          progress = Math.min(100, progress + 2);
          render();
        }, 100);
        switchTimer = window.setInterval(() => next(false), 5000);
      }

      function pause() {
        autoplay = false;
        clearTimers();
        window.clearTimeout(section._resumeStories);
        section._resumeStories = window.setTimeout(() => {
          autoplay = true;
          start();
        }, 8000);
      }

      function goTo(nextIndex, manual) {
        index = (nextIndex + slides.length) % slides.length;
        progress = 0;
        render();
        if (manual) pause();
        else start();
      }

      function next(manual) { goTo(index + 1, manual); }
      function prev(manual) { goTo(index - 1, manual); }

      nextBtns.forEach((btn) => btn.addEventListener('click', () => next(true)));
      prevBtns.forEach((btn) => btn.addEventListener('click', () => prev(true)));
      section.addEventListener('touchstart', (e) => {
        touchStart = e.changedTouches[0].clientX;
      }, { passive: true });
      section.addEventListener('touchend', (e) => {
        const diff = touchStart - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        diff > 0 ? next(true) : prev(true);
      }, { passive: true });

      section._pjRenderStory = render;
      render();
      start();
    });
  }



  function initStoneSearch(scope) {
    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const normalizeText = (value) => (value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const placeholderClass = (style) => {
      switch (style) {
        case 'dark': return ' pj-media__placeholder--dark';
        case 'leaf': return ' pj-media__placeholder--leaf';
        case 'aqua': return ' pj-media__placeholder--aqua';
        case 'amber': return ' pj-media__placeholder--amber';
        case 'rose': return ' pj-media__placeholder--rose';
        default: return '';
      }
    };

    const cardTemplate = (stone) => {
      const keywordsText = String(stone.keywords || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .join(', ');
      const imageMarkup = stone.image_url
        ? `<img class="pj-media__image" src="${escapeHtml(stone.image_url)}" alt="${escapeHtml(stone.title || '')}">`
        : `<div class="pj-media__placeholder${placeholderClass(stone.placeholder_style)}"></div>`;
      const buttonMarkup = stone.link && stone.button_label
        ? `<a class="pj-btn pj-btn--outline pj-stone-card__btn" href="${escapeHtml(stone.link)}">${escapeHtml(stone.button_label)}</a>`
        : '';
      return `
        <article class="pj-stone-card pj-stone-card--${escapeHtml(stone.placeholder_style || 'soft')} pj-reveal is-visible">
          <div class="pj-stone-card__media">
            <div class="pj-media pj-media--portrait pj-media--shadow">${imageMarkup}</div>
          </div>
          <div class="pj-stone-card__body">
            <div class="pj-collection__eyebrow">${escapeHtml(stone.subtitle || '')}</div>
            <h2 class="pj-heading-sm pj-stone-card__title">${escapeHtml(stone.title || '')}</h2>
            <p class="pj-body-sm">${escapeHtml(stone.description || '')}</p>
            ${stone.intentions ? `<div class="pj-stone-card__meta"><span class="pj-stone-card__meta-label">Ideal para</span><p>${escapeHtml(stone.intentions)}</p></div>` : ''}
            ${keywordsText ? `<p class="pj-stone-card__keywords"><span>Claves:</span> ${escapeHtml(keywordsText)}</p>` : ''}
            ${buttonMarkup}
          </div>
        </article>`;
    };

    const aliasMap = {
      amatista: ['amatista'],
      aventurina: ['aventurina'],
      fluorita: ['fluorita'],
      cornalina: ['cornalina'],
      agata: ['agata', 'agata natural'],
      turmalina: ['turmalina'],
      onix: ['onix', 'onyx'],
      espinelanegra: ['espinela negra', 'espinela'],
      peridoto: ['peridoto'],
      lapislazuli: ['lapislazuli', 'lapis lazuli', 'lapis azul', 'labis azul', 'lapiz lazuli', 'lapislasuli'],
      howlita: ['howlita'],
      piedraderio: ['piedra de rio', 'piedra rio'],
      esmeralda: ['esmeralda'],
      cuarzorosado: ['cuarzo rosado', 'cuarzo rosa'],
      cianita: ['cianita'],
      amazonita: ['amazonita'],
      zafiroazul: ['zafiro azul', 'zafiro'],
      labradorita: ['labradorita'],
      granate: ['granate'],
      obsidiana: ['obsidiana'],
      perlabarroca: ['perla barroca', 'perla'],
      jadeverdelimon: ['jade verde limon', 'jade limon', 'jade verde'],
      ojodetigre: ['ojo de tigre', 'tigre'],
      turquesa: ['turquesa']
    };

    const stoneAliases = (stone) => {
      const base = Array.isArray(stone.aliases) ? stone.aliases.slice() : (stone.aliases ? [stone.aliases] : []);
      const key = normalizeText(stone.title || '').replace(/\s+/g, '');
      return base.concat(aliasMap[key] || []);
    };

    const compact = (value) => normalizeText(value).replace(/\s+/g, '');

    const matchStoneByName = (stone, rawQuery) => {
      const qCompact = compact(rawQuery);
      if (!qCompact) return false;
      const titleCompact = compact(stone.title || '');
      if (titleCompact.includes(qCompact) || qCompact.includes(titleCompact)) return true;
      return stoneAliases(stone).some((alias) => {
        const aliasCompact = compact(alias);
        return aliasCompact.includes(qCompact) || qCompact.includes(aliasCompact);
      });
    };

    const scoreStone = (stone, rawQuery) => {
      const query = normalizeText(rawQuery);
      if (!query) return 0;
      const qCompact = compact(rawQuery);
      const title = normalizeText(stone.title || '');
      const subtitle = normalizeText(stone.subtitle || '');
      const description = normalizeText(stone.description || '');
      const intentions = normalizeText(stone.intentions || '');
      const keywords = normalizeText(stone.keywords || '');
      const aliases = normalizeText(stoneAliases(stone).join(' '));
      const titleCompact = compact(stone.title || '');
      let score = 0;
      if (titleCompact === qCompact) score += 1000;
      if (aliases.replace(/\s+/g, '').includes(qCompact)) score += 500;
      if (title.startsWith(query)) score += 260;
      if (title.includes(query)) score += 180;
      if (keywords.includes(query)) score += 90;
      if (intentions.includes(query)) score += 65;
      if (subtitle.includes(query)) score += 60;
      if (description.includes(query)) score += 45;
      if (aliases.includes(query)) score += 220;
      return score;
    };

    qsa('[data-stone-search-root]', scope).forEach((section) => {
      const input = qs('[data-stone-search-input]', section);
      const clear = qs('[data-stone-search-clear]', section);
      const grid = qs('[data-stone-search-grid]', section);
      const result = qs('[data-stone-search-result]', section);
      const empty = qs('[data-stone-search-empty]', section);
      const loadMore = qs('[data-stone-load-more]', section);
      const actions = qs('[data-stone-actions]', section);
      const fallbackScripts = qsa('[data-stone-fallback-json]', section);
      const initialVisibleCount = Math.max(1, Number(section.dataset.initialVisibleCount || 4));
      const loadMoreCount = Math.max(1, Number(section.dataset.loadMoreCount || 4));
      const apiEnabled = String(section.dataset.stonesApiEnabled || '') === 'true';
      const apiBase = String(section.dataset.stonesApiUrl || '').replace(/\/$/, '');
      if (!input || !grid) return;

      let fallbackItems = [];
      for (const script of fallbackScripts.slice().reverse()) {
        try {
          const parsed = JSON.parse(script ? script.textContent : '[]') || [];
          if (!Array.isArray(parsed)) continue;
          if (parsed.length) {
            fallbackItems = parsed;
            break;
          }
          if (!fallbackItems.length) fallbackItems = parsed;
        } catch (e) {
        }
      }

      const state = {
        displayed: [],
        query: '',
        total: fallbackItems.length,
        offset: 0,
        mode: apiEnabled && apiBase ? 'api' : 'fallback'
      };

      const placeholderTerms = Array.from(new Set(fallbackItems
        .map((item) => String(item && item.title || '').trim())
        .filter(Boolean)));

      const shuffleTerms = (terms) => terms.slice().sort(() => Math.random() - 0.5);

      const startPlaceholderTypewriter = () => {
        if (!input || !placeholderTerms.length || input.dataset.placeholderTypewriter === '1') return;
        input.dataset.placeholderTypewriter = '1';
        let pool = shuffleTerms(placeholderTerms);
        let poolIndex = 0;
        let charIndex = 0;
        let deleting = false;
        let timer = null;

        const queueNext = (delay) => {
          window.clearTimeout(timer);
          timer = window.setTimeout(tick, delay);
          section._stonePlaceholderTimer = timer;
        };

        const currentTerm = () => {
          if (!pool.length) pool = shuffleTerms(placeholderTerms);
          return pool[poolIndex] || '';
        };

        const tick = () => {
          if (!document.body.contains(input)) return;
          if (document.activeElement === input || (input.value || '').trim()) {
            queueNext(700);
            return;
          }
          const term = currentTerm();
          if (!term) return;
          if (!deleting) {
            charIndex = Math.min(charIndex + 1, term.length);
            input.setAttribute('placeholder', term.slice(0, charIndex));
            if (charIndex >= term.length) {
              deleting = true;
              queueNext(1200);
              return;
            }
            queueNext(70 + Math.round(Math.random() * 45));
            return;
          }
          charIndex = Math.max(charIndex - 1, 0);
          input.setAttribute('placeholder', term.slice(0, charIndex));
          if (charIndex <= 0) {
            deleting = false;
            poolIndex += 1;
            if (poolIndex >= pool.length) {
              pool = shuffleTerms(placeholderTerms);
              poolIndex = 0;
            }
            queueNext(260);
            return;
          }
          queueNext(34 + Math.round(Math.random() * 26));
        };

        input.addEventListener('focus', () => {
          window.clearTimeout(timer);
          input.setAttribute('placeholder', '');
        });

        input.addEventListener('blur', () => {
          if ((input.value || '').trim()) return;
          queueNext(160);
        });

        queueNext(240);
      };


      const updateMeta = (count, rawQuery) => {
        if (result) {
          if (rawQuery) result.textContent = `${count} resultado${count === 1 ? '' : 's'} para “${rawQuery}”.`;
          else result.textContent = `Mostrando ${count} de ${state.total} piedras. Usa el buscador para ver una piedra específica.`;
        }
        if (empty) empty.hidden = count !== 0;
      };

      const syncLoadMoreVisibility = () => {
        const hasQuery = Boolean((state.query || '').trim());
        const displayedCount = Array.isArray(state.displayed) ? state.displayed.length : 0;
        const totalCount = Number(state.total || 0);
        const shouldShow = !hasQuery && totalCount > initialVisibleCount && displayedCount < totalCount;
        if (loadMore) {
          loadMore.hidden = !shouldShow;
          loadMore.style.display = shouldShow ? '' : 'none';
          loadMore.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        }
        if (actions) {
          actions.hidden = !shouldShow;
          actions.style.display = shouldShow ? 'flex' : 'none';
          actions.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        }
      };

      const render = (items, append) => {
        if (!append) grid.innerHTML = '';
        if (!items.length && !append) {
          updateMeta(0, state.query);
          syncLoadMoreVisibility();
          return;
        }
        const html = items.map(cardTemplate).join('');
        if (append) grid.insertAdjacentHTML('beforeend', html);
        else grid.innerHTML = html;
        initReveal(grid);
        updateMeta(append ? state.displayed.length : items.length, state.query);
        syncLoadMoreVisibility();
      };

      const sortFallback = (items, rawQuery) => {
        if (!rawQuery) {
          return items.slice().sort((a, b) => {
            const featuredA = a.featured ? 1 : 0;
            const featuredB = b.featured ? 1 : 0;
            if (featuredA !== featuredB) return featuredB - featuredA;
            const orderA = Number.isFinite(Number(a.order)) ? Number(a.order) : Number.MAX_SAFE_INTEGER;
            const orderB = Number.isFinite(Number(b.order)) ? Number(b.order) : Number.MAX_SAFE_INTEGER;
            if (orderA !== orderB) return orderA - orderB;
            return String(a.title || '').localeCompare(String(b.title || ''), 'es');
          });
        }

        const directNameMatches = items.filter((stone) => matchStoneByName(stone, rawQuery));
        if (directNameMatches.length) {
          return directNameMatches
            .map((stone) => ({ stone, score: scoreStone(stone, rawQuery) }))
            .sort((a, b) => b.score - a.score || String(a.stone.title || '').localeCompare(String(b.stone.title || ''), 'es'))
            .map((item) => item.stone);
        }

        return items
          .map((stone) => ({ stone, score: scoreStone(stone, rawQuery) }))
          .filter((item) => item.score > 0)
          .sort((a, b) => b.score - a.score || String(a.stone.title || '').localeCompare(String(b.stone.title || ''), 'es'))
          .map((item) => item.stone);
      };

      const runFallback = (append) => {
        const rawQuery = (input.value || '').trim();
        const ordered = sortFallback(fallbackItems, rawQuery);
        state.query = rawQuery;
        state.total = ordered.length;
        if (rawQuery) {
          state.displayed = ordered;
          state.offset = ordered.length;
          render(ordered, false);
          syncLoadMoreVisibility();
          return;
        }
        const nextCount = append ? state.offset + loadMoreCount : initialVisibleCount;
        const slice = ordered.slice(0, nextCount);
        state.displayed = slice;
        state.offset = slice.length;
        render(append ? slice.slice(-loadMoreCount) : slice, append);
        syncLoadMoreVisibility();
      };

      const fetchApi = async (params) => {
        const url = new URL(`${apiBase}/stones`);
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') url.searchParams.set(key, value);
        });
        const response = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('api');
        return response.json();
      };

      const runApi = async (append) => {
        const rawQuery = (input.value || '').trim();
        state.query = rawQuery;
        try {
          const payload = await fetchApi({
            q: rawQuery,
            offset: append && !rawQuery ? state.offset : 0,
            limit: rawQuery ? 100 : (append ? loadMoreCount : initialVisibleCount)
          });
          const items = Array.isArray(payload.items) ? payload.items : [];
          state.total = Number(payload.total || items.length || 0);
          if (rawQuery) {
            state.displayed = items;
            state.offset = items.length;
            render(items, false);
            syncLoadMoreVisibility();
            return;
          }
          if (append) {
            state.displayed = state.displayed.concat(items);
            state.offset = state.displayed.length;
            render(items, true);
          } else {
            state.displayed = items;
            state.offset = items.length;
            render(items, false);
          }
          syncLoadMoreVisibility();
        } catch (error) {
          state.mode = 'fallback';
          runFallback(append);
        }
      };

      const run = (append) => {
        if (state.mode === 'api') return runApi(append);
        return runFallback(append);
      };

      section._pjRunStoneSearch = run;
      if (actions) { actions.hidden = true; actions.style.display = 'none'; }
      if (loadMore) { loadMore.hidden = true; loadMore.style.display = 'none'; }
      startPlaceholderTypewriter();

      if (section.dataset.stoneSearchBound !== '1') {
        section.dataset.stoneSearchBound = '1';
        input.addEventListener('input', () => run(false));
        if (clear) {
          clear.addEventListener('click', () => {
            input.value = '';
            run(false);
            input.focus();
          });
        }
        if (loadMore) loadMore.addEventListener('click', () => run(true));
      }
      run(false);
    });
  }


  function initTestimonials(scope) {
    qsa('[data-testimonials]', scope).forEach((section) => {
      if (section.dataset.testimonialsBound === '1') return;
      section.dataset.testimonialsBound = '1';

      let items = [];
      try {
        items = JSON.parse(section.dataset.items || '[]');
      } catch (e) {
        items = [];
      }
      if (!items.length) return;

      const product = qs('[data-testimonial-product]', section);
      const reviews = qs('[data-testimonial-reviews]', section);
      const quote = qs('[data-testimonial-quote]', section);
      const initials = qs('[data-testimonial-initials]', section);
      const name = qs('[data-testimonial-name]', section);
      const location = qs('[data-testimonial-location]', section);
      const dots = qsa('[data-testimonial-dot]', section);
      const prev = qs('[data-testimonial-prev]', section);
      const next = qs('[data-testimonial-next]', section);
      let index = 0;
      let autoplay = true;
      let timer = null;

      function render() {
        const item = items[index] || {};
        if (product) product.textContent = item.product || '';
        if (reviews) reviews.textContent = `${item.reviews || ''} reseñas`;
        if (quote) quote.textContent = `“${item.text || ''}”`;
        if (initials) initials.textContent = item.initials || '';
        if (name) name.textContent = item.name || '';
        if (location) location.textContent = item.location || '';
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      function start() {
        if (timer) window.clearInterval(timer);
        if (!autoplay) return;
        timer = window.setInterval(() => goTo(index + 1, false), 5000);
      }

      function pause() {
        autoplay = false;
        if (timer) window.clearInterval(timer);
        window.clearTimeout(section._resumeTestimonials);
        section._resumeTestimonials = window.setTimeout(() => {
          autoplay = true;
          start();
        }, 8000);
      }

      function goTo(nextIndex, manual) {
        index = (nextIndex + items.length) % items.length;
        render();
        if (manual) pause();
      }

      if (prev) prev.addEventListener('click', () => goTo(index - 1, true));
      if (next) next.addEventListener('click', () => goTo(index + 1, true));
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i, true)));
      render();
      start();
    });
  }

  function formEncode(data) {
    return Object.keys(data).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
  }

  function initCombinedContact(scope) {
    qsa('[data-combined-contact]', scope).forEach((form) => {
      if (form.dataset.contactBound === '1') return;
      form.dataset.contactBound = '1';
      const message = qs('[data-form-message]', form.parentNode);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = qs('[type="submit"]', form);
        const name = form.querySelector('[name="contact_name"]').value.trim();
        const email = form.querySelector('[name="contact_email"]').value.trim();
        const subject = form.querySelector('[name="contact_subject"]').value.trim();
        const body = form.querySelector('[name="contact_body"]').value.trim();
        if (!name || !email || !body) return;

        submit.disabled = true;
        if (message) {
          message.textContent = 'Enviando tu mensaje…';
          message.className = 'pj-form__message is-visible';
        }

        try {
          // Obtener authenticity_token que Shopify requiere en todos los POST
          const tokenMeta = document.querySelector('meta[name="csrf-token"]');
          let authToken = tokenMeta ? tokenMeta.getAttribute('content') : null;

          // Si no hay meta tag, obtenerlo desde la página de contacto
          if (!authToken) {
            const tokenPage = await fetch('/contact', { method: 'GET' });
            const tokenHtml = await tokenPage.text();
            const tokenMatch = tokenHtml.match(/name="authenticity_token"[^>]*value="([^"]+)"/);
            if (tokenMatch) authToken = tokenMatch[1];
          }

          const baseFields = authToken
            ? { authenticity_token: authToken, utf8: '✓' }
            : { utf8: '✓' };

          // Suscripción newsletter — opcional, no bloquea si falla
          try {
            await fetch('/contact', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              body: formEncode({
                ...baseFields,
                'form_type': 'customer',
                'contact[email]': email,
                'contact[tags]': 'newsletter, prospecto-piedras'
              })
            });
          } catch (_) {}

          // Envío del mensaje de contacto
          const res = await fetch('/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: formEncode({
              ...baseFields,
              'form_type': 'contact',
              'contact[name]': name,
              'contact[email]': email,
              'contact[body]': `Asunto: ${subject}\n\n${body}\n\nOrigen: formulario combinado Piedras`
            })
          });

          if (!res.ok) throw new Error('error');
          form.reset();
          if (message) {
            message.textContent = 'Mensaje enviado correctamente. Te responderemos pronto.';
            message.className = 'pj-form__message is-visible is-success';
          }
        } catch (error) {
          if (message) {
            message.textContent = 'No se pudo enviar el mensaje. Inténtalo nuevamente.';
            message.className = 'pj-form__message is-visible is-error';
          }
        } finally {
          submit.disabled = false;
        }
      });
    });
  }



  function syncCarouselButtons(viewport, prev, next) {
    if (!viewport) return;
    const maxScroll = viewport.scrollWidth - viewport.clientWidth - 4;
    if (prev) prev.disabled = viewport.scrollLeft <= 4;
    if (next) next.disabled = viewport.scrollLeft >= maxScroll;
  }

  function initTouchCarousels(scope) {
    qsa('[data-pj-carousel]', scope).forEach(function(carousel) {
      if (carousel.dataset.carouselInit === '1') return;
      carousel.dataset.carouselInit = '1';
      var viewport = qs('[data-slider-viewport]', carousel);
      if (!viewport) return;
      var prev = qs('[data-slider-prev]', carousel.parentElement || carousel);
      var next = qs('[data-slider-next]', carousel.parentElement || carousel);
      var slides = qsa('.pj-carousel__slide', carousel);
      var step = function() {
        if (slides.length > 1) {
          return Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft);
        }
        if (slides.length === 1) {
          return Math.max(1, slides[0].getBoundingClientRect().width + 10);
        }
        return Math.max(viewport.clientWidth * 0.9, 220);
      };
      if (prev) prev.addEventListener('click', function() {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
      viewport.addEventListener('scroll', function() {
        syncCarouselButtons(viewport, prev, next);
      }, { passive: true });
      window.setTimeout(function() { syncCarouselButtons(viewport, prev, next); }, 60);
      window.addEventListener('resize', function() { syncCarouselButtons(viewport, prev, next); });
    });
  }

  function initProductGallery(scope) {
    qsa('[data-product-gallery-slider]', scope).forEach(function(shell) {
      if (shell.dataset.galleryInit === '1') return;
      shell.dataset.galleryInit = '1';
      var viewport = qs('[data-slider-viewport]', shell);
      var track = qs('[data-slider-track]', shell);
      var dotsWrap = qs('[data-product-gallery-dots]', shell);
      if (!viewport || !track) return;
      var slides = qsa('[data-gallery-slide]', shell);
      var dots = qsa('[data-product-gallery-dots] [data-slide-to]', shell);
      var prev = qs('[data-slider-prev]', shell);
      var next = qs('[data-slider-next]', shell);
      var activeIndex = Math.max(0, Number(dotsWrap && dotsWrap.dataset.initialIndex || 0));

      function updateDots() {
        dots.forEach(function(btn, i) {
          btn.classList.toggle('is-active', i === activeIndex);
        });
      }

      function goTo(index, smooth) {
        activeIndex = clamp(index, 0, slides.length - 1);
        viewport.scrollTo({ left: viewport.clientWidth * activeIndex, behavior: smooth === false ? 'auto' : 'smooth' });
        updateDots();
        syncCarouselButtons(viewport, prev, next);
      }

      dots.forEach(function(btn) {
        btn.addEventListener('click', function() {
          goTo(Number(btn.dataset.slideTo || 0), true);
        });
      });
      if (prev) prev.addEventListener('click', function() { goTo(activeIndex - 1, true); });
      if (next) next.addEventListener('click', function() { goTo(activeIndex + 1, true); });

      var ticking = false;
      viewport.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          var index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
          activeIndex = clamp(index, 0, slides.length - 1);
          updateDots();
          syncCarouselButtons(viewport, prev, next);
          ticking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', function() { goTo(activeIndex, false); });
      window.setTimeout(function() { goTo(activeIndex, false); }, 40);
    });
  }
  
  function initCollectionShuffle(scope) {
    qsa('.pj-product-grid', scope).forEach(function (grid) {
      var items = Array.from(grid.children);
      if (items.length < 2) return;
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = items[i]; items[i] = items[j]; items[j] = t;
      }
      items.forEach(function (item) { grid.appendChild(item); });
    });
  }

  function initAll(scope) {
    const root = scope && scope.nodeType === 1 ? scope : document;
    initAnnouncement(root);
    initHeader(root);
    initPredictiveSearch(root);
    initReveal(root);
    initProcess(root);
    initStories(root);
    initStoneSearch(root);
    initTestimonials(root);
    initProductGallery(root);
    initTouchCarousels(root);
    initCollectionShuffle(root);
    initCombinedContact(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const section = event.target && event.target.closest ? event.target.closest('.shopify-section') : null;
    if (section) initAll(section);
  });
})();
